// extracted by css-extract-rspack-plugin
var _1 = true;
var _2 = "arrow-ncOVP";
export { _1 as "__esModule", _2 as "arrow" }
export default { "__esModule": _1, "arrow": _2 }
